module.exports = __webpack_public_path__ + "img/1014.c7aac02c.jpg";